import './src/sass/_base.scss';
import { wrapWithLaunchDarkly } from './src/helper/launchdarkly-provider';
import { wrapPageElementWithGtmNoScript } from './src/components/google-tag-manager-noscript';

export const wrapRootElement = wrapWithLaunchDarkly;
export const wrapPageElement = wrapPageElementWithGtmNoScript;

// Enhanced smooth scrolling for anchor links
export const onRouteUpdate = ({ location }) => {
   document.body.classList.remove('overlay__active');

   // Handle anchor links with smooth scrolling
   if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
         setTimeout(() => {
            element.scrollIntoView({
               behavior: 'smooth',
               block: 'start',
               inline: 'nearest',
            });
         }, 100); // Small delay to ensure page is rendered
      }
   }
};

// Add smooth scrolling to all anchor links on client-side
export const onInitialClientRender = () => {
   // Enhanced smooth scrolling with easing for anchor links
   const addSmoothScrolling = () => {
      document.addEventListener('click', (e) => {
         const link = e.target.closest('a[href*="#"]');
         if (!link) return;

         const href = link.getAttribute('href');
         const isCurrentPageAnchor =
            href.startsWith('#') || href.includes(window.location.pathname + '#');

         if (isCurrentPageAnchor) {
            e.preventDefault();
            const targetId = href.split('#')[1];
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
               // Use native smooth scrolling for better performance
               targetElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                  inline: 'nearest',
               });

               // Update URL hash after a short delay
               setTimeout(() => {
                  window.history.replaceState(null, null, href);
               }, 100);
            }
         }
      });
   };

   // Add the smooth scrolling once DOM is ready
   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addSmoothScrolling);
   } else {
      addSmoothScrolling();
   }
};
